"use strict";
/* eslint-disable @typescript-eslint/ban-types */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 创建一个 memoized 函数，会使用 WeakMap 缓存结果。
 *
 * 对于这个 memoized 函数：
 *
 * - 如果多次调用，传入同一个 object 引用来调用，会返回上次生成的值而无需重新执行 fn 函数。
 * - 如果传入的不是 object，会直接调用 fn 并返回结果。
 */
function memoWithWeakMap(fn) {
    let map = new WeakMap();
    const memoizedFunction = function (a) {
        if (typeof a !== 'object' || a === null)
            return fn(a);
        const objA = a;
        if (map.has(objA))
            return map.get(objA);
        const answer = fn(a);
        map.set(objA, answer);
        return answer;
    };
    memoizedFunction.clear = () => {
        map = new WeakMap();
    };
    memoizedFunction.delete = (a) => {
        if (typeof a === 'object' && a !== null)
            map.delete(a);
    };
    memoizedFunction.get = (a) => map.get(a);
    return memoizedFunction;
}
exports.default = memoWithWeakMap;
